"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var style_1 = require("../../../style");
var SvgIcFacebook = function () { return (react_1.default.createElement(style_1.SvgIcon, { height: '1em', viewBox: '0 0 24 24', width: '1em' },
    react_1.default.createElement("path", { className: 'SvgIcon__FillHoverColor', d: 'M12.984 18v-5.5h1.777l.224-1.894h-2.001v-.949c0-.498.056-.76.894-.76H15V7h-1.796c-2.135 0-2.884.921-2.884 2.461v1.141H9V12.5h1.335V18z', fill: '#777' }))); };
exports.default = SvgIcFacebook;
